import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCursorClick32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconCursorClick32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.955 14.519Q17 14.265 17 14a3 3 0 1 0-2.481 2.955l2.377 8.32a1 1 0 0 0 1.88.119l1.561-3.642 3.956 3.955a1 1 0 0 0 1.414-1.414l-3.956-3.956 3.643-1.56a1 1 0 0 0-.12-1.881zM7 14a7 7 0 0 0 6.46 6.98l.505 2.02A9 9 0 1 1 23 14v.039l-2.017-.538A7 7 0 0 0 7 14m15.02 4.046-2.393 1.026-.042.018-.347.148-.148.347-.018.042-1.026 2.394-1.59-5.565z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCursorClick32);
